export const useMessage = () => {
  const toast = useToastApp()

  const showError = (message?: string, title?: string): boolean => {
    toast.$showError(message, title)
    console.log(message, title)
    return false
  }

  const showMessage = (message?: string, title?: string): boolean => {
    toast.$showMessage(message, title)
    console.log(message, title)
    return false
  }

  const showWarning = (message?: string, title?: string): boolean => {
    toast.$showWarning(message, title)
    console.log(message, title)
    return false
  }

  return { showError, showMessage, showWarning }
}
